/* [EZ] PDP description See More / Close (#6) — collapse the product description to 5 visual
   lines (line-height × 5, regardless of markup — a single long paragraph clamps the same as a
   list) behind a toggle that slides open/closed. Progressive enhancement, no core edits:
   targets Horizon's description block by its stable id-suffix class. */
(function () {
  var LIMIT = 5;
  var CHEVRON = '<svg class="ez-rm__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  function build(desc) {
    if (desc.dataset.ezRm) return;

    // Collapse to LIMIT *visual lines* (line-height × LIMIT), independent of markup, so a
    // single long paragraph clamps at 5 lines just like a bulleted list would.
    var cs = window.getComputedStyle(desc);
    var lh = parseFloat(cs.lineHeight);
    if (isNaN(lh)) lh = (parseFloat(cs.fontSize) || 16) * 1.4; // 'normal' line-height fallback
    var collapsed = Math.round(lh * LIMIT);
    if (desc.scrollHeight <= collapsed + 4) return; // 5 lines or fewer — nothing to hide

    // Wrap the description content so we can clip/animate its height.
    var clip = document.createElement('div');
    clip.className = 'ez-rm__clip';
    while (desc.firstChild) clip.appendChild(desc.firstChild);
    desc.appendChild(clip);

    clip.style.maxHeight = collapsed + 'px';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ez-rm__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="ez-rm__label">See More</span>' + CHEVRON;
    desc.appendChild(btn);
    desc.classList.add('ez-rm');

    btn.addEventListener('click', function () {
      var open = !desc.classList.contains('is-open');
      if (open) {
        clip.style.maxHeight = clip.scrollHeight + 'px';
        clip.addEventListener('transitionend', function te() {
          clip.style.maxHeight = 'none'; // allow reflow once fully open
          clip.removeEventListener('transitionend', te);
        });
      } else {
        clip.style.maxHeight = clip.scrollHeight + 'px'; // from 'none' → fixed, so it can animate
        void clip.offsetHeight;                          // force reflow
        clip.style.maxHeight = collapsed + 'px';
      }
      desc.classList.toggle('is-open', open);
      btn.querySelector('.ez-rm__label').textContent = open ? 'Close' : 'See More';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    desc.dataset.ezRm = '1';
  }

  function init() {
    var d = document.querySelector('[class*="__text_aEtTtq"]');
    if (d) build(d);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
